import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Layout from "../../components/Layout.js";
import { apiFetch } from "../../api.js";

const CreditcardmasterGrid = () => {
  const navigate = useNavigate();
  const [gridData, setGridData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchGridData = async () => {
    try {
      const response = await apiFetch(
        "/api/creditcard/grid",
      );
      const data = await response.json();
      setGridData(data);
      setFilteredData(data);
    } catch (err) {
      console.error("❌ Error fetching Credit Card grid:", err);
      alert("Unable to fetch data from backend.");
    }
  };

  const handleSearch = async () => {
    try {
      if (searchTerm.trim() === "") {
        const response = await apiFetch(
          "/api/creditcard/grid",
          {
            method: "GET",
          },
        );

        if (!response.ok) {
          const err = await response.text();
          console.error("GRID ERROR:", err);
          alert("Failed to load grid");
          return;
        }

        const data = await response.json();
        setGridData(data);
        setFilteredData(data);
      } else {
        const response = await apiFetch(
          `/api/creditcard/search?q=${encodeURIComponent(searchTerm)}`, // ✅ FIX
          {
            method: "GET",
          },
        );

        if (!response.ok) {
          const err = await response.text();
          console.error("SEARCH ERROR:", err);
          alert("Search failed");
          return;
        }

        const data = await response.json();
        setGridData(data);
        setFilteredData(data);
      }

      setCurrentPage(1);
    } catch (err) {
      console.error("❌ Error searching Credit Card grid:", err);
      alert("Unable to fetch search results.");
    }
  };

  async function handleDelete(id) {
    if (!window.confirm("Are you sure you want to delete this record?")) return;

    try {
      const response = await apiFetch(
        `/api/creditcard/delete/${id}`,
        {
          method: "DELETE",
        },
      );

      // ✅ check response
      if (!response.ok) {
        const errText = await response.text();
        console.error("DELETE ERROR:", errText);
        alert("Delete failed!");
        return;
      }

      const data = await response.json(); // ✅ FIX

      const message = data.message || "";

      if (message.toLowerCase().includes("deleted")) {
        alert(message);
        fetchGridData();
      } else if (message.toLowerCase().includes("not found")) {
        alert(message);
      } else if (message.toLowerCase().includes("name use")) {
        alert(message);
      } else {
        alert(`Unexpected response: ${message}`);
      }
    } catch (err) {
      console.error("❌ Error deleting record:", err);
      alert("Unable to delete record. Please try again.");
    }
  }

  useEffect(() => {
    fetchGridData();
  }, []);

  const totalPages = Math.ceil(filteredData.length / pageSize);
  const startIndex = (currentPage - 1) * pageSize;
  const paginatedData = filteredData.slice(startIndex, startIndex + pageSize);

  async function handleEdit(id) {
    try {
      const res = await apiFetch(
        `/api/creditcard/edit/${id}`,
      );

      // ✅ check response
      if (!res.ok) {
        const errText = await res.text();
        console.error("EDIT FETCH ERROR:", errText);
        alert("Failed to fetch record!");
        return;
      }

      const fullData = await res.json();

      const editPayload = Array.isArray(fullData) ? fullData[0] : fullData;

      // ✅ safe validation
      if (!editPayload || !editPayload.sp_492) {
        alert("Record not found or invalid format.");
        return;
      }

      navigate("/Creditcard", { state: { editData: editPayload } });
    } catch (err) {
      console.error("Failed to fetch record:", err);
      alert("Unable to fetch record. Check backend.");
    }
  }
  /*------------------- Styles--------------*/
  const pageContainerStyle = {
    width: "100%",
    minHeight: "calc(100vh - 70px)",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "16px",
    backgroundColor: "#f4f6f8",
    boxSizing: "border-box",
  };

  const containerStyle = {
    width: "100%",
    maxWidth: "1100px",
    margin: "0 auto",
    padding: "16px",
    borderRadius: "10px",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
    backgroundColor: "#fff",
    boxSizing: "border-box",
  };

  const headerStyle = {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
    marginBottom: "15px",
  };

  const leftHeaderStyle = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "center",
    gap: "8px",
    flex: 1,
    minWidth: "250px",
  };
  const titleStyle = {
    fontSize: "1.2rem",
    fontWeight: "bold",
    flexShrink: 0,
  };
  const addButtonStyle = {
    padding: "8px 16px",
    backgroundColor: "#3a28a0ff",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  };
  const searchInputStyle = {
    flex: "1 1 250px",
    maxWidth: "450px",
    minWidth: "200px",
    padding: "8px",
    borderRadius: "4px",
    border: "1px solid #ccc",
  };

  const searchButtonStyle = {
    padding: "8px 12px",
    backgroundColor: "#2196F3",
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    whiteSpace: "nowrap",
  };
  const selectStyle = {
    padding: "8px 10px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    backgroundColor: "#fff",
    whiteSpace: "nowrap",
  };
  const tableWrapperStyle = { overflowX: "auto" };
  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    minWidth: "400px",
  };
  const thStyle = {
    padding: "10px",
    textAlign: "left",
    backgroundColor: "#8B1E3F",
    color: "#fff",
    border: "1px solid #ddd",
    whiteSpace: "nowrap",
    fontSize: "0.9rem",
  };
  const tdStyle = {
    padding: "8px",
    border: "1px solid #ddd",
    wordWrap: "break-word",
    fontSize: "0.85rem",
  };
  const actionButtonStyle = (bgColor) => ({
    padding: "6px 10px",
    marginRight: "5px",
    backgroundColor: bgColor,
    color: "#fff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    minWidth: "60px",
    fontSize: "0.8rem",
  });
  const paginationStyle = {
    marginTop: "12px",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: "10px",
    fontSize: "0.9rem",
  };
  const pageBtnStyle = {
    padding: "6px 12px",
    borderRadius: "4px",
    border: "1px solid #ccc",
    cursor: "pointer",
    background: "#f9f9f9",
    fontSize: "0.85rem",
  };

  return (
    <Layout>
      <div style={containerStyle}>
        <div style={headerStyle}>
          <div
            style={{
              display: "flex",
              gap: "10px",
              flexWrap: "wrap",
              alignItems: "center",
            }}
          >
            <div style={titleStyle}>Card Master Grid</div>
            <input
              type="text"
              placeholder="Search..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={searchInputStyle}
            />
            <button style={searchButtonStyle} onClick={handleSearch}>
              Search
            </button>
            <select
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                setCurrentPage(1);
              }}
              style={{
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
              }}
            >
              {[10, 20, 50, 100].map((size) => (
                <option key={size} value={size}>
                  {size} / page
                </option>
              ))}
            </select>
          </div>
          <button
            style={addButtonStyle}
            onClick={() => navigate("/Creditcard")}
          >
            Add New
          </button>
        </div>

        <div style={tableWrapperStyle}>
          <div style={tableWrapperStyle}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Card Name</th>
                  <th style={thStyle}>Account Name</th>
                  <th style={thStyle}>Abbreviation</th>
                  <th style={thStyle}>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.length > 0 ? (
                  paginatedData.map((row) => (
                    <tr key={row.uniqueId}>
                      <td style={tdStyle}>{row.cardName}</td>
                      <td style={tdStyle}>{row.accountName}</td>
                      <td style={tdStyle}>{row.abbreviation}</td>
                      <td style={tdStyle}>
                        <button
                          style={{
                            ...pageBtnStyle,
                            backgroundColor: "#4CAF50",
                            color: "#fff",
                            marginRight: "5px",
                          }}
                          onClick={() => handleEdit(row.uniqueId)}
                        >
                          Edit
                        </button>

                        <button
                          style={{
                            ...pageBtnStyle,
                            backgroundColor: "#f44336",
                            color: "#fff",
                          }}
                          onClick={() => handleDelete(row.uniqueId)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="4" style={tdStyle}>
                      No records found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div style={paginationStyle}>
          <button
            style={pageBtnStyle}
            disabled={currentPage === 1}
            onClick={() => setCurrentPage((p) => p - 1)}
          >
            Prev
          </button>
          <span>
            Page {currentPage} of {totalPages || 1}
          </span>
          <button
            style={pageBtnStyle}
            disabled={currentPage === totalPages || totalPages === 0}
            onClick={() => setCurrentPage((p) => p + 1)}
          >
            Next
          </button>
        </div>
      </div>
    </Layout>
  );
};

export default CreditcardmasterGrid;
